<section class="cmn-innerpage-wrapper">
  <div class="head">
    <div class="head-div">
      <div class="search-wrapper">
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search Themes"
          (input)="onSearch($event)"
        />
      </div>
      <button
        *appHasPermission="'ADD_THEME'"
        (click)="createNewTheme()"
        class="cmn-add-btn"
      >
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Theme
      </button>
    </div>
  </div>
  <div *ngIf="!loading && !noData && themesArray.length">
    <div class="themesWrapper">
      <div class="themeItem" *ngFor="let theme of themesArray">
        <h6>{{ theme.themeName }}</h6>
        <button *appHasPermission="'DELETE_THEME'" (click)="onDeleteTheme(theme.id)">
          <img class="themeRemoveIcon" src="../../../assets/images/icons/icon-delete.svg" alt="Remove" />
        </button>
        <button *appHasPermission="'UPDATE_THEME'" (click)="onEditTheme(theme.id)">
          <img class="themeEditIcon" src="../../../assets/images/icons/icon-edit.svg" alt="Edit" />
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="noData && !loading">
    <app-no-data-component></app-no-data-component>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
